import { Box, Group, Select, Stack, Text, useMantineTheme } from '@mantine/core';
import type { BulletCharacter, ExportBrandingConfigData } from '../types';
import { BULLET_OPTIONS } from '../types';

type Props = {
  config: ExportBrandingConfigData;
  onChange: (config: ExportBrandingConfigData) => void;
};

const LEVELS: {
  key: keyof ExportBrandingConfigData['bullet_styles'];
  label: string;
}[] = [
  { key: 'level_2_bullet', label: 'Level 1 (List Bullet 2)' },
  { key: 'level_3_bullet', label: 'Level 2 (List Bullet 3)' },
  { key: 'level_4_bullet', label: 'Level 3 (List Bullet 4)' },
];

export default function BulletStylesForm({ config, onChange }: Props) {
  const bullets = config.bullet_styles;
  const theme = useMantineTheme();

  return (
    <Stack gap="md">
      {LEVELS.map(({ key, label }) => (
        <Group key={key} align="flex-end">
          <Select
            label={label}
            data={BULLET_OPTIONS}
            value={bullets[key]}
            onChange={v =>
              v &&
              onChange({
                ...config,
                bullet_styles: {
                  ...bullets,
                  [key]: v as BulletCharacter,
                },
              })
            }
            style={{ flex: 1, maxWidth: 300 }}
          />
          <Text size="xl" pb={4}>
            {bullets[key]}
          </Text>
        </Group>
      ))}

      <Box
        p="md"
        bg="gray.0"
        style={{
          borderRadius: 16,
          border: `1px solid ${theme.colors.gray[2]}`,
        }}
      >
        <Stack gap={4}>
          <Text>{bullets.level_2_bullet} First level item</Text>
          <Text pl="md">{bullets.level_3_bullet} Second level item</Text>
          <Text pl="xl">{bullets.level_4_bullet} Third level item</Text>
        </Stack>
      </Box>
    </Stack>
  );
}
